import React from 'react';
import './material-icons.css';

const ICON_GLYPHS = {
  close: 'close',
  phone: 'phone',
  email: 'email',
  location_on: 'location_on',
  facebook: 'facebook',
  camera_alt: 'camera_alt',
  mail: 'mail',
  warning: 'warning',
  palette: 'palette',
  devices: 'devices',
  auto_awesome: 'auto_awesome',
  edit: 'edit',
  add: 'add',
  delete: 'delete_outline',
  upload: 'file_upload',
  error: 'cancel',
  credit_card: 'credit_card',
  local_offer: 'local_offer',
  vpn_key: 'vpn_key',
};

function MaterialIcon({ name, className = '', size, title, ...rest }) {
  const glyph = ICON_GLYPHS[name] || ICON_GLYPHS.warning;
  const sizeClass =
    size === 16 ? 'material-icons--size-16' : size === 20 ? 'material-icons--size-20' : '';
  const classes = ['material-icons', 'app-material-icon', 'material-icons--font', sizeClass, className]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} aria-hidden={title ? undefined : true} title={title} {...rest}>
      {glyph}
    </span>
  );
}

export function hasMaterialIcon(name) {
  return Boolean(ICON_GLYPHS[name]);
}

export default MaterialIcon;
